import * as React from "react";
import { Dialog } from "@/components/ui/dialog";
import { BusinessReportSelectFileContent } from "./content";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";

interface Props {
  businessReport: BusinessReport;
  onClose: () => void;
}

export const BusinessReportSelectFileModal: React.FC<Props> = ({ businessReport, onClose }) => {
  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      {isOpen && <BusinessReportSelectFileContent businessReport={businessReport} setIsOpen={setIsOpen} />}
    </Dialog>
  );
};
